import { computed, observable, component } from 'knockout-decorators'

import { IdentityProvider, LoginStatus } from '@tixa/schema'
import { pageState } from '~/store/page'
import { Language } from '~/utils'

import type { SignInOptions } from '../utils/options'
import { authState } from '../utils/state'

import source from './link-accounts.html?raw'

@component('link-accounts-form', source)
export class LinkAccountsForm {
  constructor(private options: SignInOptions) {}
  private Locale = Language.getInstance()

  public i18n(key: string): string {
    return this.Locale.translations[key]
  }

  private state = authState
  @observable public isFeedbackVisible = false
  @observable public loginIdp: IdentityProvider | undefined = undefined

  @computed get canLogin(): boolean {
    return this.state.email.length > 0 && this.state.password.length > 0
  }

  private async linkAuthLogin() {
    if (this.state.isLoading) return
    this.isFeedbackVisible = false
    this.state.isLoading = true

    const loginResponse = await pageState.api.authentication.login({
      provider: this.loginIdp,
      email: this.state.email,
      token: this.state.token,
      password: this.state.password,
    })
    if (loginResponse.status === LoginStatus.success) {
      // assuming server acknowledged login, redirect
      this.options.signedIn(this.state.email)
    } else {
      // nope
      this.isFeedbackVisible = true
      this.state.isLoading = false
    }
  }

  private gotoLogin() {
    if (this.state.isLoading) return
    this.options.signIn()
  }

  private gotoLostpass() {
    if (this.state.isLoading) return
    this.options.lostPassword(this.state.email)
  }
}
